module.exports = __webpack_public_path__ + "static/media/agent-icon.f8080bfb.svg";